var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKidney2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60.238,
    height: 60.238,
    viewBox: "0 0 60.238 60.238",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_8",
    "data-name": "Group 8",
    transform: "translate(1.4 1.4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Stroke_25",
    "data-name": "Stroke 25",
    d: "M0,28.72A28.719,28.719,0,1,1,28.719,57.438,28.719,28.719,0,0,1,0,28.72Z",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#33f",
    strokeWidth: 2.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_31",
    "data-name": "Fill 31",
    d: "M17.583,32.445a1.353,1.353,0,0,1-1.352-1.352V16.22a1.353,1.353,0,0,0-1.352-1.352H13.4a6.26,6.26,0,0,0,.18,1.916,6.1,6.1,0,0,1-1.642,5.847,5.846,5.846,0,0,1-4.108,1.7,5.935,5.935,0,0,1-1.592-.219,7.913,7.913,0,0,1-4.849-4.049A13.854,13.854,0,0,1,.725,9.52,15.22,15.22,0,0,1,5.046,2.637,9.727,9.727,0,0,1,11.368,0a7.327,7.327,0,0,1,2.05.291,5.887,5.887,0,0,1,2.7,1.69,5.731,5.731,0,0,1,1.327,2.6,6.088,6.088,0,0,1-1.9,5.828,6.557,6.557,0,0,0-1.37,1.751h.709a4.061,4.061,0,0,1,4.056,4.056V31.093A1.354,1.354,0,0,1,17.583,32.445ZM11.327,2.707A7.057,7.057,0,0,0,6.613,4.828a12.751,12.751,0,0,0-3.3,5.487,11.31,11.31,0,0,0,.455,8.465A5.282,5.282,0,0,0,6.9,21.489a3.477,3.477,0,0,0,.936.132,3.1,3.1,0,0,0,2.2-.921,3.34,3.34,0,0,0,.918-3.242,9.42,9.42,0,0,1,.117-4.911A9.207,9.207,0,0,1,13.738,8.4a3.372,3.372,0,0,0,1.071-3.224A3.021,3.021,0,0,0,12.718,2.9,4.952,4.952,0,0,0,11.327,2.707Z",
    transform: "translate(8.439 14.877)",
    fill: "#33f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_33",
    "data-name": "Fill 33",
    d: "M1.353,32.429A1.354,1.354,0,0,1,0,31.076V16.2a4.061,4.061,0,0,1,4.056-4.056h.708A6.5,6.5,0,0,0,3.4,10.4a6.059,6.059,0,0,1-1.9-5.835A5.681,5.681,0,0,1,5.425.3,7.554,7.554,0,0,1,7.543,0,9.774,9.774,0,0,1,13.9,2.634,15.173,15.173,0,0,1,18.212,9.5a13.856,13.856,0,0,1-.661,10.543A7.928,7.928,0,0,1,12.8,24.07a6.307,6.307,0,0,1-1.689.235A5.837,5.837,0,0,1,7,22.615,6.1,6.1,0,0,1,5.36,16.768a6.235,6.235,0,0,0,.179-1.917H4.056A1.353,1.353,0,0,0,2.7,16.2V31.076A1.354,1.354,0,0,1,1.353,32.429ZM7.631,2.678a4.811,4.811,0,0,0-1.352.192A3.036,3.036,0,0,0,4.128,5.153,3.375,3.375,0,0,0,5.2,8.38a9.193,9.193,0,0,1,2.665,4.152,9.423,9.423,0,0,1,.117,4.911A3.332,3.332,0,0,0,8.9,20.684a3.1,3.1,0,0,0,2.209.927,3.276,3.276,0,0,0,.871-.12,5.274,5.274,0,0,0,3.193-2.727,11.312,11.312,0,0,0,.456-8.464C14.27,5.883,10.907,2.678,7.631,2.678Z",
    transform: "translate(30.062 14.894)",
    fill: "#33f"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKidney2);
export default __webpack_public_path__ + "static/media/kidney_2.d0bb4ace718e79f9c4f09473e52b1660.svg";
export { ForwardRef as ReactComponent };